import React, { useEffect } from 'react';
import { SeoHead, ProductBreadcrumb, FaqSection } from './SeoShared';
import { EFFY_FUEL_PRODUCT, FUEL_FEATURE_GROUPS, FUEL_FAQS, FUEL_URL } from '../products/effyFuelContent';
import { FuelCta } from '../products/FuelCta';
import '../products/EffyOrder.css';
import './SeoPages.css';

// /products/effy-fuel/features — everything Effy Fuel does, grouped by the part of the day it helps with.
export default function FuelFeaturesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="oi-page-v2">
      <SeoHead
        path={EFFY_FUEL_PRODUCT.featuresPath}
        title="Effy Fuel Features – Shift Sales, Credit Customers, Stock & Reports | EffyVenture"
        description="All Effy Fuel features in one place: shift sales, credit customers, printable statements, salesperson cash check, fuel and oil stock, purchases, expenses and Excel reports for petrol bunks."
        breadcrumbName="Features"
        product={EFFY_FUEL_PRODUCT}
        faqs={FUEL_FAQS}
      />

      <section className="oi-hero-v2 seo-hero--center">
        <div className="seo-hero__center">
          <ProductBreadcrumb product={EFFY_FUEL_PRODUCT} current="Features" />
          <div className="oi-badge-v2">Effy Fuel features</div>
          <h1 className="oi-hero-v2__title">
            Everything your petrol bunk needs, <span className="text-gradient">in one simple app.</span>
          </h1>
          <p className="oi-hero-v2__subtitle">
            Shifts, credit customers, staff cash, stock and reports. It works on your phone, tablet or computer.
          </p>
          <div className="oi-hero-v2__actions seo-hero__actions">
            <a href={`${FUEL_URL}/signup`} className="btn-v2 btn-v2--primary">Try it free</a>
            <a href={`${FUEL_URL}/login`} className="btn-v2 btn-v2--secondary">Sign In</a>
          </div>
        </div>
      </section>

      <div className="seo-groups">
        {FUEL_FEATURE_GROUPS.map(group => (
          <section key={group.title} className="seo-group">
            <h2 className="seo-group__title">
              <span className="seo-group__icon" aria-hidden="true">{group.icon}</span>
              {group.title}
            </h2>
            <div className="seo-group__grid">
              {group.items.map(item => (
                <div key={item.name} className="seo-card">
                  <h3 className="seo-card__name">{item.name}</h3>
                  <p className="seo-card__text">{item.text}</p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>

      <FaqSection faqs={FUEL_FAQS} />
      <FuelCta />
    </div>
  );
}
